import { isNullOrEmpty } from '@core/utils/object-helpers';
import { Timestamped } from '@core/models/timestamped';

export interface TimestampedDTO {
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
}

export function toDate(value: string | undefined): Date | undefined {
    return isNullOrEmpty(value) ? value : new Date(value);
}

export const dtoToModelDef = {
    createdAt: toDate,
    updatedAt: toDate,
    deletedAt: toDate as (v: TimestampedDTO['deletedAt']) => Timestamped['deletedAt'],
};
